import { Formik } from "formik";
import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import * as Yup from "yup";
import countries from "../../_shared/constants/countries";
import { corePlans } from "./_shared/constants/products";
// TODO: convert this to a SCSS module at this level
import "./register/Register.scss";
import promoCodes from "./_shared/constants/promoCodes";
import Routes from "./Routes";
import { FormValues } from "./_shared/models/FormValues";

const validationSchema = Yup.object({
  firstName: Yup.string().required("You must enter your first name"),
  lastName: Yup.string().required("You must enter your last name"),
  email: Yup.string()
    .required("You must enter your email")
    .matches(/\S+@\S+\.\S+/, "You must enter a valid email address."),
  phone: Yup.string().required("You must enter your phone number."),
  password: Yup.string().required("You must enter your password."),
  confirmPassword: Yup.string()
    .required("You must confirm your password.")
    .oneOf([Yup.ref("password"), null], "Make sure your passwords match.")
    .min(6, "Your password must be at least 6 characters long."),
  // billingName: Yup.string().required("You must enter your full name."),
  // billingCountry: Yup.string().required("You must select a country or region."),
  // billingZipCode: Yup.string().required("You must enter your zip code."),
  acceptsTerms: Yup.bool().oneOf(
    [true],
    "You must read and accept the Terms and Conditions.",
  ),
  promo: Yup.string().oneOf(
    promoCodes.map((code) => code.promo),
    "Invalid promo code",
  ),
});

export const initialValues = {
  // signup
  firstName: "",
  lastName: "",
  email: "",
  areaCode: "+1",
  phone: "",
  password: "",
  confirmPassword: "",
  twitter: "",
  brokerage: "",
  referral: "",
  // plan select
  plan: "free_plan",
  frequency: "daily",
  // addons select
  addOns: [],
  promo: "",
  // pay with card
  billingName: "",
  billingCountry: countries[0],
  billingZipCode: "",
  acceptsTerms: false,
  verified42Macro: "",
} as FormValues;

const Signup: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);

  // set initial values based on URL params
  const urlPlan = urlParams.get("prodid");
  const urlPromo = urlParams.get("promo");
  const email = urlParams.get("email");
  const fname = urlParams.get("fname");
  const lname = urlParams.get("lname");
  const addons = urlParams.get("addons");

  useEffect(() => {
    // if user opens on a nested step, bring them back to first step
    const isNested = location.pathname.split("/").length > 2;
    if (isNested) history.replace("/signup");
  }, []); // eslint-disable-line

  return (
    <>
      <Formik
        initialValues={
          {
            ...initialValues,
            plan:
              corePlans.find((item) => urlPlan === item.prodid)?.prod ??
              initialValues.plan,
            promo: urlPromo ?? initialValues.promo,
            email: email ?? initialValues.email,
            firstName: fname ?? initialValues.firstName,
            lastName: lname ?? initialValues.lastName,
            addOns: addons?.includes('bullseye_ai_trade_ideas') ? ['bullseye_ai_trade_ideas'] : []
          } as FormValues
        }
        validationSchema={validationSchema}
        onSubmit={() => console.log("form submission")}
      >
        <Routes />
      </Formik>
    </>
  );
};

export default Signup;
